import React from 'react'
import {Container, Row, Col} from 'react-bootstrap';
import './stepContainer.scss'
import HubbleIQBlack from "../../../images/HubbleIQ_black.png";

const StepContainer = (props) => {
    const {
        stepTitle,
        stepDescription,
        stepClassName,
        stepImage,
        children
    } = props;
    return (
        <>
            <Container id="mainStepContainer" fluid>
                <Row className={stepClassName}>
                    <Container>
                        <Row className={'justify-content-center'}>
                            <Col xs={12} md={6} className={'modal-like-column d-flex flex-column'}>
                                <Row className={'justify-content-center'}>
                                    <Col>
                                        <img src={HubbleIQBlack} alt="HubbleIQ Logo" className={'logo'}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className={'step-title mx-auto'}>
                                        <h3>{stepTitle}</h3>
                                        <img src={stepImage}/>
                                        <p>{stepDescription}</p>
                                    </Col>
                                </Row>
                                { children }
                            </Col>
                        </Row>
                    </Container>
                </Row>
            </Container>
        </>
    )
}

export default StepContainer
